<template>
    <v-dialog v-model="showDialog" width="800px">
        <v-card>
            <v-card-title class="justify-center">View, add & delete rules</v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pt-4"><b>{{ akcd.akcd_oms }}</b></v-card-text>
            <v-divider></v-divider>
            <v-card-text>
                <v-data-table 
                    :items="akcd.akpr" 
                    :items-per-page="10" 
                    :footer-props="{'items-per-page-options': [10, 50, 100, 200, -1]}"
                    :headers="headers">
                    <!-- :search="search">  -->
                    <template v-slot:item="props">
                        <tr>
                            <td>{{ props.item.akpr_regel }}</td>
                            <td><btn_component type="icon" icon="mdi-trash-can-outline" color="red" tooltip="Delete rule" size="x-small" :data="props.item" @actionClick="deleteRule"/></td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <btn_component type="text" text="Add rule" color="primary" tooltip="Add a new rule" size="x-small" :data="true" @actionClick="addRule"/>
                <v-spacer></v-spacer>
                <btn_component type="text" text="Close" color="primary" tooltip="close" size="x-small" data="" @actionClick="closeDialog"/>
            </v-card-actions>
        </v-card>
        <akcd_addAkpr ref="akcd_addAkpr" @addedAkpr="addedAkpr"/>
        <akcd_rmAkpr ref="akcd_rmAkpr" @deletedAkpr="deletedAkpr"/>
    </v-dialog>
</template>

<script>
    import btn_component from "@/components/ui/buttons/btn_component.vue";
    import akcd_addAkpr from "@/components/syst/ref/akcd/akcd_addAkpr.vue";
    import akcd_rmAkpr from "@/components/syst/ref/akcd/akcd_rmAkpr.vue";
    
    export default {
        components: {
            btn_component,
            akcd_addAkpr,
            akcd_rmAkpr,
        },    
        data() {
            return {
                showDialog: false,
                akcd: {
                    akcd_oms: "",
                },
                rules: [],
                headers: [
                    { text: "Rule description", value: "akpr_oms", width: "90%" },
                    { text: "Delete", value: "", width: "10%" },
                ],
            }
        },  
        methods: {  
            openDialog(akcd) {
                this.akcd = akcd;
                this.showDialog = true;
                // this.getAkprs(akcd.akcd_encrid);
            },
            addRule() {
                this.$refs.akcd_addAkpr.openDialog(this.akcd);
            },
            addedAkpr(akpr) {
                this.akcd.akpr.push(akpr);
            },
            deleteRule(akpr) {
                console.log(akpr)
                this.$refs.akcd_rmAkpr.openDialog(akpr);
            },
            deletedAkpr(akpr_encrid) {
                let tmp = [];
                for (let iIndex=0;iIndex< this.akcd.akpr.length;iIndex++) {
                    
                    if (this.akcd.akpr[iIndex].akpr_encrid !== akpr_encrid) {
                        tmp.push(this.akcd.akpr[iIndex]);
                    }
                }
                this.akcd.akpr = tmp;
            },
            closeDialog() {
                this.$emit("refreshList");
                this.showDialog = false;
            },
        }
    }
</script>

<style scoped> 

</style>